/**
 * Owner: Masa Bayu
 * File: malay-glue-words.ts
 * Date:Time: 2026-10-15 08:02
 * Description: F2.0 · language-tagged Malay sealed-word glue · default OFF.
 */

/**
 * Sealed Malay word list · NOT geometry · NOT morphology.
 * Used only to drop pdf.js whitespace that splits a known word when
 * join options explicitly set language to Malay (ms*).
 * Must never run as default (G28 · English / unlabeled).
 */
const WORDS: readonly string[] = [
  'keruntuhan',
  'pemerintahannya',
  'memelihara',
  'tersebut',
  'umayyah',
  'bahawa',
  'semata',
];

export const MALAY_GLUE_WORDS: ReadonlySet<string> = new Set(WORDS);

/** BCP-47 primary subtag · Malay only. */
export function isMalayGlueLanguage(language: string | undefined | null): boolean {
  if (typeof language !== 'string' || language.trim().length === 0) return false;
  const primary = language.trim().toLowerCase().split(/[-_]/u)[0] ?? '';
  return primary === 'ms';
}

/**
 * True when trailing letters of prev + leading letters of next form a sealed word
 * AND language is explicitly Malay. Default / English / unlabeled → false.
 */
export function shouldGlueLetterParts(
  prev: string,
  next: string,
  language?: string | null,
): boolean {
  if (!isMalayGlueLanguage(language)) return false;
  const left = prev.replace(/\s+$/u, '').match(/[\p{L}]+$/u)?.[0] ?? '';
  const right = next.replace(/^\s+/u, '').match(/^[\p{L}]+/u)?.[0] ?? '';
  if (!left || !right) return false;
  return MALAY_GLUE_WORDS.has((left + right).toLowerCase());
}
